var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies, Layout, Auth } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import NumberRange from "~/components/common/number-range.vue";
import { Getter, Mutation, namespace, State } from "vuex-class";
import { CaseAssistService } from "~/services/domain-service/case-assist.service.ts";
import CaseMarker from "~/components/common/case-marker.vue";
import { ApplyType, CASE_CHANNEL, MENU_CHANNEL } from "~/config/enum.config";
import GetLabelName from "~/components/labeling-strategy/get-label-name.vue";
import LeaveCaseApply from "~/components/apply-component/leave-case-apply.vue";
import CaseAllot from "~/components/distribution-common/case-allot.vue";
var AllotModule = namespace("case-allot");
var AssistVisitCollection = /** @class */ (function (_super) {
    __extends(AssistVisitCollection, _super);
    function AssistVisitCollection() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.caseChannel = CASE_CHANNEL.assist_visit;
        _this.applyType = ApplyType.assistLeave;
        // private caseMark: any = "";
        _this.searchModel = {
            caseNumber: "",
            batchNumber: "",
            principalId: "",
            personalName: "",
            idCard: "",
            loanDate: [],
            mobileNo: "",
            partnerName: "",
            bankName: "",
            mainDeptName: "",
            currentCollectorRealName: "",
            loanAmount: { min: "", max: "" },
            loanPeriod: { min: "", max: "" },
            overdueAmount: { max: "", min: "" },
            businessAddress: "",
            boardAddress: "",
            plateNum: "",
            collectionType: "",
            flowInTime: [],
            personalCollectionRemainingDays: { min: "", max: "" },
            deptId: [],
            assistCollectorName: "",
            flag: false,
        };
        _this.dataSet = [];
        _this.selectionList = [];
        _this.dialog = {
            ManualDivision: false,
            apply: false
        };
        return _this;
    }
    AssistVisitCollection.prototype.mounted = function () {
        this.refreshData();
    };
    AssistVisitCollection.prototype.activated = function () {
        this.refreshData();
    };
    Object.defineProperty(AssistVisitCollection.prototype, "departmentType", {
        //过滤协催来源
        get: function () {
            // 要过滤的字段
            var disabledDepartmentTypes = ["WAIT_DISTRIBUTE", "UNIVERSAL", "OUTER", "STOP", "LAW", "CHEAT", "VERIFIER", "REPAIR", "GRAB_CASE", "RECOVERED"];
            return this.$dict.getDictData('DepartmentType').filter(function (v) { return !disabledDepartmentTypes.includes(v.code); });
        },
        enumerable: false,
        configurable: true
    });
    AssistVisitCollection.prototype.refreshData = function () {
        var _this = this;
        this.caseAssistService
            .getAllVisitCaseAssist(this.searchModel, this.pageService, this.sortService)
            .subscribe(function (data) {
            _this.dataSet = data;
            _this.selectionList = [];
        });
    };
    /**
     * 留案申请
     */
    AssistVisitCollection.prototype.leaveApply = function () {
        if (this.selectionList.length === 0) {
            this.$message.info("请选择要分配的案件");
            return;
        }
        this.dialog.apply = true;
    };
    /**
     * 重新分案
     */
    AssistVisitCollection.prototype.manualDivision = function () {
        if (this.selectionList.length === 0) {
            this.$message.info("请选择要分配的案件");
            return;
        }
        this.updateCaseIds(this.selectionList.map(function (v) { return v.caseId; }));
        var caseAssistIds = this.selectionList.map(function (v) { return v.id; });
        this.updateExtData({ caseAssistIds: caseAssistIds });
        this.dialog.ManualDivision = true;
    };
    /**
     * 进入编辑执行页
     */
    AssistVisitCollection.prototype.openExecutionPage = function (row) {
        this.$router.openCaseDetail(row.caseId, {
            menuChannel: MENU_CHANNEL.Assist_visit,
            hiddenAction: row.assistStatus === "ASSIST_OVER",
            otherData: {
                assistId: row.id
            }
        });
    };
    /**
     * 重置numberRange
     */
    AssistVisitCollection.prototype.follFeedback = function () {
        this.searchModel.overdueAmount = { min: "", max: "" };
        this.searchModel.overdueDays = { min: "", max: "" };
        this.searchModel.caseMoney = { min: "", max: "" };
    };
    Object.defineProperty(AssistVisitCollection.prototype, "selectedIds", {
        get: function () {
            return this.selectionList.map(function (v) { return v.caseId; });
        },
        enumerable: false,
        configurable: true
    });
    AssistVisitCollection.prototype.onColorChange = function (val) {
        var colorModel = {
            caseAssistIds: this.selectionList.map(function (v) { return v.id; }),
            caseMark: val
        };
        this.caseAssistService
            .markCaseAssistColor(colorModel)
            .subscribe(this.refreshData);
    };
    __decorate([
        Dependencies(PageService)
    ], AssistVisitCollection.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], AssistVisitCollection.prototype, "sortService", void 0);
    __decorate([
        Dependencies(CaseAssistService)
    ], AssistVisitCollection.prototype, "caseAssistService", void 0);
    __decorate([
        Getter
    ], AssistVisitCollection.prototype, "visitDepartmentDataNoRoot", void 0);
    __decorate([
        Getter
    ], AssistVisitCollection.prototype, "departmentData", void 0);
    __decorate([
        Mutation
    ], AssistVisitCollection.prototype, "updateCollectionType", void 0);
    __decorate([
        AllotModule.Mutation
    ], AssistVisitCollection.prototype, "updateCaseIds", void 0);
    __decorate([
        AllotModule.Mutation
    ], AssistVisitCollection.prototype, "updateExtData", void 0);
    __decorate([
        State
    ], AssistVisitCollection.prototype, "principalList", void 0);
    AssistVisitCollection = __decorate([
        Auth(1502),
        Layout("workspace"),
        Component({
            components: {
                GetLabelName: GetLabelName,
                CaseAllot: CaseAllot,
                NumberRange: NumberRange,
                CaseMarker: CaseMarker,
                LeaveCaseApply: LeaveCaseApply
            }
        })
    ], AssistVisitCollection);
    return AssistVisitCollection;
}(Vue));
export default AssistVisitCollection;
